import { useEventListener } from "./use-event-listener";

/**
 * Uses a conditional dialog to confirm that the user wants to leave the page.
 */
export function useBeforeUnload(enabled) {
  useEventListener("beforeunload", event => {
    if (enabled) {
      event.preventDefault();
      // @ts-ignore
      event.returnValue = "Changes you made may not be saved.";
    }
  }, window);
}